import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ExtraOptions, PreloadAllModules } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from './core/services/auth/auth.service';
import { environment } from '../environments/environment';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { appConfig } from 'app/core/config/app.config';
import { LayoutModule } from 'app/layout/layout.module';
import {
    SocialLoginModule,
    SocialAuthServiceConfig,
} from '@abacritt/angularx-social-login';
import { GoogleLoginProvider } from '@abacritt/angularx-social-login';
import { NgParticlesModule } from 'ng-particles';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { QuillModule } from 'ngx-quill';
import { AkitaNgRouterStoreModule } from '@datorama/akita-ng-router-store';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { ReactiveFormsModule } from '@angular/forms';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';

registerLocaleData(en);

const GoogleClientId = environment.GoogleClientId;
const googleLoginOptions = {
    scope: 'email',
    plugin_name: 'streamy',
};

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    enableTracing: true,
};
@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        FormsModule,
        CoreModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        SocialLoginModule,
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        LayoutModule,
        NgParticlesModule,
        NgxExtendedPdfViewerModule,
        MarkdownModule.forRoot({}),
        QuillModule.forRoot(),
        ReactiveFormsModule,
        NzSpinModule,
        NzIconModule.forRoot([]),
        environment.production ? [] : AkitaNgDevtools,
        AkitaNgRouterStoreModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        AuthService,
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider(
                            GoogleClientId,
                            googleLoginOptions
                        ),
                    },
                ],
                onError: (err) => {
                    console.error(err);
                },
            } as SocialAuthServiceConfig,
        }
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
